import { render, staticRenderFns } from "./task-part-list.vue?vue&type=template&id=109f7a7b&scoped=true"
import script from "./task-part-list.vue?vue&type=script&lang=js"
export * from "./task-part-list.vue?vue&type=script&lang=js"
import style0 from "./task-part-list.vue?vue&type=style&index=0&id=109f7a7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109f7a7b",
  null
  
)

export default component.exports